import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, CircularProgress, Typography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ProgressIndicatorIcon = function ProgressIndicatorIcon(props) {
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      position: 'relative',
      display: 'inline-flex'
    },
    "data-element": "Box",
    "data-component": "ProgressIndicatorIcon",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx(CircularProgress, _objectSpread(_objectSpread({
      variant: "determinate"
    }, props), {}, {
      "data-element": "CircularProgress",
      "data-component": "ProgressIndicatorIcon",
      "data-source-file": "index.tsx"
    })), /*#__PURE__*/_jsx(Box, {
      sx: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      "data-element": "Box",
      "data-source-file": "index.tsx",
      children: /*#__PURE__*/_jsxs(Typography, {
        variant: "caption",
        component: "div",
        color: "textSecondary",
        "data-element": "Typography",
        "data-source-file": "index.tsx",
        children: [Math.round(props.value), "%"]
      })
    })]
  });
};